import React, { useEffect, useState } from "react"
import { Link, useLocation, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Space, Button, Input, Popconfirm, notification, Tag } from "antd"
import { EditOutlined, PlusOutlined, SearchOutlined, DeleteOutlined } from "@ant-design/icons"
import _ from 'lodash'

/* CUSTOM COMPONENT */
import Header from "../../../component/Header/Header"
import { PageContainer, Xpagination, Xtable } from "../../../component/Xcomponent"

/* ACTION */
import { getAdminTypeList, getAdminTypeListReset } from '../../../action/getAdminTypeListAction'
import { deleteAdminType, deleteAdminTypeReset } from '../../../action/deleteAdminTypeAction'

/* OTHERS */
import { checkRights } from '../../../utils'


const AdminTypeMasterList = (props) => {
    /* VARIABLES */
    const {
        getAdminTypeList, getAdminTypeListReset, getAdminTypeListState,
        deleteAdminType, deleteAdminTypeReset, deleteAdminTypeState,
    } = props
    const search = useLocation().search;
    const page = new URLSearchParams(search).get('page');
    const [tableData, setTableData] = useState([])
    const [refresh, setRefresh] = useState(0)
    const [searchText, setSearchText] = useState({})
    const [redirect, setRedirect] = useState(["", false])

    const [pagination, setPagination] = useState({
        page: page ? page : 1,
        records: 20,
    })

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        setSearchText({
            ...searchText,
            [dataIndex]: selectedKeys[0]
        })
    }

    const handleReset = (clearFilters, dataIndex) => {
        let remainSearch = _.omit(searchText, [dataIndex])
        clearFilters()
        setSearchText(remainSearch)
    }


    const getColumnSearchProps = (dataIndex, name) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${name}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => [handleSearch(selectedKeys, confirm, dataIndex), setPagination({ ...pagination, ['page']: 1 })]}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => handleReset(clearFilters, dataIndex)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    });



    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            ...getColumnSearchProps('name', 'Name')
        },
        {
            title: 'Module Name',
            dataIndex: 'module_name',
            key: 'module_name',
            render: (module_name) => <Space wrap>
                {module_name?.length > 0 && module_name.map(item => (
                    <Tag style={{ marginBottom: 8 }}>{item.name} </Tag>
                ))}
            </Space>,
            ...getColumnSearchProps('module_name', 'Module Name')
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (action) => (
                <Space size="small">
                    {checkRights("admin_type", "edit") &&
                        <Link to={`/admin-type/save/${action.id}`}><Button size="small" shape="circle" icon={<EditOutlined />} /></Link>
                    }
                    {checkRights("admin_type", "delete") &&
                        <Popconfirm
                            title="Are you sure to delete this item?"
                            onConfirm={() => deleteAdminType({ id: action.id })}
                            okText="Delete"
                            cancelText="Cancel"
                            okType="danger"
                        >
                            <Button size="small" shape="circle" icon={<DeleteOutlined />} />
                        </Popconfirm>
                    }
                </Space >
            )
        },
    ];
    /* CALLBACKS */

    useEffect(() => {
        getAdminTypeList({
            dropDownList: "",
            page: pagination.page,
            records: pagination.records,
            ...searchText
        })
        setRedirect([true, `/admin-type/list?page=${pagination.page}`])

    }, [pagination, refresh, searchText])

    useEffect(() => {
        return (() => {
            getAdminTypeListReset()
            deleteAdminTypeReset()
        })
    }, [])

    useEffect(() => {
        if (deleteAdminTypeState.apiState === "success") {
            notification["success"]({
                message: "Delete Records Successfully"
            })
            deleteAdminTypeReset()
            getAdminTypeList({ dropDownList: "" })
        }
        if (deleteAdminTypeState.apiState === "error") {
            notification["error"]({
                message: "Something went wrong"
            })
            deleteAdminTypeReset()
        }
    }, [deleteAdminTypeState])


    useEffect(() => {
        if (getAdminTypeListState.apiState === "success") {
            let tableData = []
            getAdminTypeListState.list.map((row, index) => {
                tableData.push(
                    {
                        key: index,
                        name: row.name,
                        module_name: row.module_master,
                        action: { id: row._id }
                    }
                )
            })
            setTableData(tableData)
        }
    }, [getAdminTypeListState])

    return (
        <>
            {redirect[0] &&
                <Redirect to={redirect[1]} />}
            <Header
                title="Admin Type List"
                rightChildren={checkRights("admin_type", "add") && <Link to="/admin-type/save" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                {getAdminTypeListState.apiState === "error" &&
                    <div style={{ height: 500, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }} >
                        <p>{getAdminTypeListState.message}</p>
                        <Button type="primary" onClick={() => setRefresh(refresh + 1)} >TRY AGAIN</Button>
                    </div>
                }

                {getAdminTypeListState.apiState !== "error" &&
                    <>
                        <Xtable columns={columns} dataSource={tableData} pagination={false} scroll={{ x: 768 }}
                            loading={getAdminTypeListState.apiState === "loading"}
                        />
                        <Xpagination
                            pageSizeOptions={['25', '50', '100', '500']}
                            showSizeChanger
                            total={getAdminTypeListState.pagination?.total_records}
                            onChange={(page, pageSize) => setPagination({ page: page, records: pageSize })}
                            current={pagination.page}
                            defaultPageSize={pagination.records}
                            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                        />
                    </>
                }
            </PageContainer>
        </>
    )
}
const mapStateToProps = (state) => ({
    getAdminTypeListState: state.getAdminTypeList,
    deleteAdminTypeState: state.deleteAdminType,

})
const mapDispatchToProps = (dispatch) => ({
    getAdminTypeList: (params) => dispatch(getAdminTypeList(params)),
    getAdminTypeListReset: () => dispatch(getAdminTypeListReset()),
    deleteAdminType: (params) => dispatch(deleteAdminType(params)),
    deleteAdminTypeReset: () => dispatch(deleteAdminTypeReset()),
})

export default connect(mapStateToProps, mapDispatchToProps)(AdminTypeMasterList)
